import styled from 'styled-components';
import { BaseEditField } from 'legacyComponents/styled/lib';

export const DescriptionWrapper = styled.div`
  margin: 5px auto 10px auto;
`;

export const Description = styled.p`
  font-size: 1.25em;
  text-align: center;
  line-height: 1.4;
`;

export const DescriptionInput = styled(BaseEditField)`
  position: relative;
  width: 640px;
  font-size: 1.25em;
  line-height: 1.4;
  margin: -2px auto 6px auto;
  display: block;
  text-align: center;
  > textarea {
    padding: 0;
    text-align: center;
    min-height: inherit;
    line-height: 1.4;
  }
`;
